import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";

const videoConstraints = {
    width: 600,
    height: 400,
    facingMode: "user",
};

const ImagePicker = ({ preview, onSelect }) => {
    const fileInputRef = useRef(null);
    const [openCamera, setOpenCamera] = useState(false);

    const webcamRef = useRef(null);

    useEffect(() => {
        if (!openCamera) return;
        navigator.mediaDevices
            .getUserMedia({ video: true })
            .then(() => console.log("✅ Camera permission granted"))
            .catch((err) => console.error("❌ Camera permission denied", err));
    }, [openCamera])
    const capturePhoto = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        onSelect({ target: { files: [dataURLtoFile(imageSrc, "captured.jpg")] } });
         stopCamera();    
        setOpenCamera(false);
    };
    const stopCamera = () => {
        if (webcamRef.current && webcamRef.current.video && webcamRef.current.video.srcObject) {
            let stream = webcamRef.current.video.srcObject;
            stream.getTracks().forEach(track => track.stop()); // 🔥 Stop webcam
        }
    };
    // ✅ Convert DataURL → File (needed for FormData upload)
    function dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700">
                Profile Photo
            </label>
            <div className="flex items-start">

                {/* ✅ Preview */}
                {preview ? (
                    <img
                        src={preview}
                        alt="Preview"
                        className="mt-2 w-32 h-32 object-cover rounded-md border border-gray-300 shadow-sm"
                    />
                ) : (
                    <div className="mt-2 w-32 h-32 rounded-md border border-gray-300 shadow-sm flex items-center justify-center text-gray-400 text-sm">
                        No Image
                    </div>
                )}

                {/* ✅ Buttons */}
                <div className="mt-4 space-y-3 ">
                    {/* 📸 Capture Button */}
                    <button
                        type="button"
                        onClick={() => setOpenCamera(true)}
                        className="w-full py-2   text-blue-600 rounded-md hover:bg-blue-50 transition"
                    >
                        Capture Photo
                    </button>

                    {/* 📁 Upload Button */}
                    <button
                        type="button"
                        onClick={() => fileInputRef.current.click()}
                        className="w-full py-2 text-gray-700 rounded-md hover:bg-gray-100 transition"
                    >
                        Upload File
                    </button>
                </div>


            </div>

            {/* ✅ File Upload */}
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={onSelect}
                className="hidden"
            />

            {/* ✅ Popup Camera UI */}
            {openCamera && (
                <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg">
                        <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            videoConstraints={videoConstraints}
                            className="rounded-md"
                        />

                        <div className="mt-3 flex gap-3 justify-center">
                            <button
                                onClick={capturePhoto}
                                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                            >
                                Capture
                            </button>

                            <button
                                onClick={() => setOpenCamera(false)}
                                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default React.memo(ImagePicker);
